import { createContext, useContext } from 'react';

import { ContextStore } from 'bernie-core';

export const PlatformContext = createContext({} as ContextStore);

export function usePlatformContext() {
  return useContext(PlatformContext);
}
